// Only presentation boilerplate associated with an active stage form belongs
// here. Do not apply this to free-form chat or suppress substantive guidance.
export function isGenericStageFormCopy(value: unknown): boolean {
  if (typeof value !== 'string') return false;
  const copy = value.trim().replace(/\s+/g, ' ').replace(/[.!]$/, '').toLowerCase();
  return copy === 'saved sample inputs'
    || copy === 'please answer these questions so we can continue'
    || copy === 'please answer these follow-up questions so we can continue'
    || copy === 'please answer the following questions to continue'
    || /^please review and complete the .+ fields below$/.test(copy);
}

export function stageFormGuidance(...values: unknown[]): string[] {
  return Array.from(new Set(values.flatMap(value => (
    typeof value === 'string' && value.trim() && !isGenericStageFormCopy(value)
      ? [value.trim()] : []
  ))));
}

// Call only after server visibility rules have selected the displayed history.
// With no per-message stage identity, only the final unanswered assistant turn
// can be associated with the current form; equal older prompts are history.
export function withoutActiveStagePrompt<T extends { role: string; content?: unknown }>(
  messages: T[], pendingPrompt: unknown,
): T[] {
  const latest = messages[messages.length - 1];
  return latest?.role === 'assistant' && typeof latest.content === 'string'
    && typeof pendingPrompt === 'string' && isGenericStageFormCopy(latest.content)
    && latest.content.trim() === pendingPrompt.trim()
    ? messages.slice(0, -1) : messages;
}
